const ResourcesConstants = {
    NativeAnswerTexts: {
        YesAnswer: "Yes",
        NoAnswer: "No",
        MeetsWithExemptions: "Meets With Exemptions",
        NoResponse: "no response",
        Tested: "Tested",
        Other : "Other"
    },
    UniversalFieldIds: {
        ReferenceDate: "reference-date",
        SupplierComments: "supplier-comments"
    }
}

export default ResourcesConstants;